<div class="flex justify-between items-center p-6 p border-b bg-white dark:bg-transparent">
  <div>
    <h2 class="text-2xl font-bold tracking-tight text-gray-800">
      Gestionar Versiones - {{ data?.version?.name ?? "Nueva Aplicación" }}
    </h2>
    <p class="text-secondary font-medium">
      Gestione las versiones de la aplicación
    </p>
  </div>
  <div class="flex items-center gap-2">
    <button mat-icon-button (click)="close()" matTooltip="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content p-0 m-0 flex-auto flex flex-col bg-gray-50/50 overflow-hidden">
  <ng-container>
    <form [formGroup]="form" class="p-6 overflow-y-auto space-y-4 custom-scrollbar">
      <div
        class="flex items-start gap-3 p-4 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800">
        <mat-icon class="text-amber-600 dark:text-amber-500 mt-0.5">warning</mat-icon>
        <div>
          <p class="text-sm text-amber-700 dark:text-amber-300 m-0">
            La configuración es estricta. Solo las versiones configuradas podrán operar. El uso incorrecto puede ocasionar problemas de sincronización para usuarios fuera de las versiones permitidas.
          </p>
        </div>
      </div>

      <ng-container *ngIf="isEditMode">
        <div class="rounded-lg border border-slate-200 dark:border-slate-700 p-4 bg-slate-50 dark:bg-slate-800/30">
          <p class="text-sm text-slate-500 dark:text-slate-400 mb-1">Seleccionar Aplicación</p>
          <p class="font-medium text-slate-800 dark:text-slate-200 m-0">{{ form.get('name')?.value }}</p>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 m-0">{{ form.get('code')?.value }}</p>
        </div>
      </ng-container>
      <ng-container *ngIf="!isEditMode">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Seleccionar Aplicación</mat-label>
          <mat-select
            formControlName="subApplication"
            placeholder="Seleccione una sub aplicación"
          >
            <mat-option
              *ngFor="let type of listSubAplication || []"
              [value]="type._id"
            >
              {{ type.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <div formGroupName="versions">
        <h3 class="text-base font-semibold text-slate-700 dark:text-slate-300 mb-4">Configuración por Plataforma</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div *ngFor="let platform of platformOrder"
            class="flex flex-col gap-2 p-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50 hover:border-primary/30 transition-colors">
            <div class="flex items-center gap-2">
              <mat-icon class="text-slate-500 dark:text-slate-400">{{ platformIcons[platform] }}</mat-icon>
              <span class="font-medium text-slate-800 dark:text-slate-200">{{ platformLabels[platform] }}</span>
            </div>
            <p class="text-xs text-slate-500 dark:text-slate-400 m-0">{{ platformStores[platform] }}</p>
            <mat-form-field appearance="fill" class="w-full mt-1">
              <mat-label>Versión</mat-label>
              <input matInput [formControlName]="platform" placeholder="Ej: 3.4.4" />
              <mat-error *ngIf="versionsGroup.get(platform)?.hasError('required') && versionsGroup.get(platform)?.touched">
                La versión es obligatoria
              </mat-error>
              <mat-error *ngIf="versionsGroup.get(platform)?.hasError('pattern') && !versionsGroup.get(platform)?.hasError('required') && versionsGroup.get(platform)?.touched">
                El formato debe ser X.Y.Z (ej: 1.0.0)
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions flex items-center justify-end gap-3 bg-gray-50 dark:bg-background-dark/50 px-6 py-3 border-t border-primary/10">
  <button mat-button (click)="close()" [disabled]="saving">Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid || saving">
    {{ saving ? 'Guardando...' : 'Guardar' }}
  </button>
</mat-dialog-actions>